// extracted by mini-css-extract-plugin
export var required = "_it-0";